export const groovySoundWavesAnimation = {
  v: '4.8.0',
  meta: { g: 'LottieFiles AE 3.4.5', a: '', k: '', d: '', tc: '' },
  fr: 24,
  ip: 0,
  op: 32,
  w: 16,
  h: 16,
  nm: 'Main Comp',
  ddd: 0,
  assets: [
    {
      id: 'comp_0',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 3,
          nm: 'NULL ALL',
          sr: 1,
          ks: {
            o: { a: 0, k: 0, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [198, 282, 0], ix: 2 },
            a: { a: 0, k: [50, 50, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          ip: 9,
          op: 47,
          st: 15,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: '01',
          parent: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [5, 50, 0], ix: 2 },
            a: { a: 0, k: [-60.336, 43.977, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                { t: 0, s: [100, 24.172, 100], h: 1 },
                {
                  i: { x: [0.662, 0.712, 0.662], y: [1, 1.84, 1] },
                  o: { x: [0.321, 0.576, 0.321], y: [0, 0, 0] },
                  t: 9,
                  s: [100, 89, 100],
                },
                {
                  i: { x: [0.667, 0.658, 0.666], y: [1, 0.911, 1] },
                  o: { x: [0.332, 0.295, 0.332], y: [0, 0.362, 0] },
                  t: 19,
                  s: [100, 129.422, 100],
                },
                {
                  i: { x: [0.676, 0.669, 0.675], y: [1, 0.826, 1] },
                  o: { x: [0.339, 0.33, 0.339], y: [0, -0.07, 0] },
                  t: 26,
                  s: [100, 67.369, 100],
                },
                {
                  i: { x: [0.713, 0.462, 0.713], y: [1, 0.996, 1] },
                  o: { x: [0.347, 0.343, 0.347], y: [0, -0.239, 0] },
                  t: 31,
                  s: [100, 121.857, 100],
                },
                {
                  i: { x: [0.763, 0.763, 0.763], y: [1, 1, 1] },
                  o: { x: [0.403, 0.744, 0.403], y: [0, 0, 0] },
                  t: 38,
                  s: [100, 64.555, 100],
                },
                { t: 47, s: [100, 89, 100] },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ty: 'rc',
                  d: 1,
                  s: { a: 0, k: [19.328, 94.977], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: 'Rectangle Path 1',
                  mn: 'ADBE Vector Shape - Rect',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [0.098039215686, 0.533333333333, 0.243137254902, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [-60.336, -3.512], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Rectangle 1',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 0,
          op: 47,
          st: 15,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: '02',
          parent: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [35, 50, 0], ix: 2 },
            a: { a: 0, k: [-60.336, 43.977, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                { t: 0, s: [100, 24.2, 100], h: 1 },
                {
                  i: { x: [0.53, 0.53, 0.53], y: [1, 1, 1] },
                  o: { x: [0.22, 0.22, 0.22], y: [0, 0, 0] },
                  t: 9,
                  s: [100, 46.188, 100],
                },
                {
                  i: { x: [0.53, 0.53, 0.53], y: [1, 1, 1] },
                  o: { x: [0.22, 0.22, 0.22], y: [0, 0, 0] },
                  t: 18,
                  s: [100, 114.697, 100],
                },
                {
                  i: { x: [0.53, 0.53, 0.53], y: [1, 1, 1] },
                  o: { x: [0.22, 0.22, 0.22], y: [0, 0, 0] },
                  t: 23,
                  s: [100, 70.298, 100],
                },
                {
                  i: { x: [0.53, 0.53, 0.53], y: [1, 1, 1] },
                  o: { x: [0.22, 0.22, 0.22], y: [0, 0, 0] },
                  t: 30,
                  s: [100, 124.022, 100],
                },
                {
                  i: { x: [0.53, 0.53, 0.53], y: [1, 1, 1] },
                  o: { x: [0.22, 0.22, 0.22], y: [0, 0, 0] },
                  t: 39,
                  s: [100, 15.775, 100],
                },
                { t: 47, s: [100, 46.188, 100] },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ty: 'rc',
                  d: 1,
                  s: { a: 0, k: [19.328, 94.977], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: 'Rectangle Path 1',
                  mn: 'ADBE Vector Shape - Rect',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [0.098039215686, 0.533333333333, 0.243137254902, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [-60.336, -3.512], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Rectangle 1',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 0,
          op: 47,
          st: 15,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: '04',
          parent: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [95, 50, 0], ix: 2 },
            a: { a: 0, k: [-60.336, 43.977, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                { t: 0, s: [100, 24.172, 100], h: 1 },
                {
                  i: { x: [0.656, 0.673, 0.656], y: [1, 1.01, 1] },
                  o: { x: [0.321, 0.34, 0.321], y: [0, -0.015, 0] },
                  t: 9,
                  s: [100, 89, 100],
                },
                {
                  i: { x: [0.663, 0.672, 0.662], y: [1, 0.988, 1] },
                  o: { x: [0.328, 0.339, 0.328], y: [0, 0.004, 0] },
                  t: 15,
                  s: [100, 38.218, 100],
                },
                {
                  i: { x: [0.665, 0.673, 0.665], y: [1, 0.991, 1] },
                  o: { x: [0.331, 0.34, 0.331], y: [0, 0.018, 0] },
                  t: 18,
                  s: [100, 98.699, 100],
                },
                {
                  i: { x: [0.667, 0.674, 0.667], y: [1, 0.988, 1] },
                  o: { x: [0.333, 0.341, 0.333], y: [0, -0.008, 0] },
                  t: 21,
                  s: [100, 141.378, 100],
                },
                {
                  i: { x: [0.67, 0.676, 0.67], y: [1, 1.01, 1] },
                  o: { x: [0.336, 0.342, 0.336], y: [0, -0.017, 0] },
                  t: 24,
                  s: [100, 88.96, 100],
                },
                {
                  i: { x: [0.679, 0.686, 0.679], y: [1, 0.935, 1] },
                  o: { x: [0.343, 0.352, 0.343], y: [0, 0.014, 0] },
                  t: 27,
                  s: [100, 127.377, 100],
                },
                {
                  i: { x: [0.679, 0.682, 0.679], y: [1, 0.998, 1] },
                  o: { x: [0.345, 0.348, 0.345], y: [0, -0.067, 0] },
                  t: 32,
                  s: [100, 76.951, 100],
                },
                {
                  i: { x: [0.686, 0.687, 0.686], y: [1, 1.059, 1] },
                  o: { x: [0.351, 0.353, 0.351], y: [0, 0.002, 0] },
                  t: 35,
                  s: [100, 109.966, 100],
                },
                {
                  i: { x: [0.698, 0.696, 0.698], y: [1, 0.759, 1] },
                  o: { x: [0.363, 0.362, 0.363], y: [0, 0.051, 0] },
                  t: 38,
                  s: [100, 149.147, 100],
                },
                {
                  i: { x: [0.735, 0.718, 0.735], y: [1, 1, 1] },
                  o: { x: [0.396, 0.383, 0.396], y: [0, 4.095, 0] },
                  t: 41,
                  s: [100, 96.787, 100],
                },
                { t: 47, s: [100, 89, 100] },
              ],
              ix: 6,
            },
          },
          ao: 0,
          ef: [
            {
              ty: 5,
              nm: 'Slider Control',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 1,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: { a: 0, k: 0, ix: 1 },
                },
              ],
            },
            {
              ty: 5,
              nm: 'Slider Control 2',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 2,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: { a: 0, k: 0, ix: 1 },
                },
              ],
            },
          ],
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ty: 'rc',
                  d: 1,
                  s: { a: 0, k: [19.328, 94.977], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: 'Rectangle Path 1',
                  mn: 'ADBE Vector Shape - Rect',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [0.098039215686, 0.533333333333, 0.243137254902, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [-60.336, -3.512], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Rectangle 1',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 0,
          op: 47,
          st: 15,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 5,
          ty: 4,
          nm: '03',
          parent: 1,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [65, 50, 0], ix: 2 },
            a: { a: 0, k: [-60.336, 43.977, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                { t: 0, s: [100, 24.172, 100], h: 1 },
                {
                  i: { x: [0.682, 0.787, 0.681], y: [1, 0.629, 1] },
                  o: { x: [0.35, 0.462, 0.349], y: [0, -0.028, 0] },
                  t: 9,
                  s: [100, 120, 100],
                },
                {
                  i: { x: [0.833, 0.52, 0.833], y: [1, -0.89, 1] },
                  o: { x: [0.35, 0.268, 0.349], y: [0, -0.858, 0] },
                  t: 16,
                  s: [100, 78.756, 100],
                },
                {
                  i: { x: [0.685, 0.652, 0.684], y: [1, 0.699, 1] },
                  o: { x: [0.333, 0.276, 0.333], y: [0, 0.23, 0] },
                  t: 20,
                  s: [100, 84.887, 100],
                },
                {
                  i: { x: [0.681, 0.662, 0.68], y: [1, 1.252, 1] },
                  o: { x: [0.349, 0.382, 0.347], y: [0, 0.755, 0] },
                  t: 25,
                  s: [100, 132.286, 100],
                },
                {
                  i: { x: [0.682, 0.391, 0.681], y: [1, 0.784, 1] },
                  o: { x: [0.36, 0.333, 0.357], y: [0, 0.147, 0] },
                  t: 30,
                  s: [100, 144.264, 100],
                },
                {
                  i: { x: [0.674, 0.619, 0.675], y: [1, 1.026, 1] },
                  o: { x: [0.346, 0.699, 0.347], y: [0, 0.049, 0] },
                  t: 36,
                  s: [100, 119.976, 100],
                },
                {
                  i: { x: [0.663, 0.823, 0.666], y: [1, -0.357, 1] },
                  o: { x: [0.332, 0.375, 0.334], y: [0, -0.655, 0] },
                  t: 40,
                  s: [100, 80, 100],
                },
                { t: 47, s: [100, 100, 100] },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ty: 'rc',
                  d: 1,
                  s: { a: 0, k: [19.328, 94.977], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  r: { a: 0, k: 0, ix: 4 },
                  nm: 'Rectangle Path 1',
                  mn: 'ADBE Vector Shape - Rect',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [0.098039215686, 0.533333333333, 0.243137254902, 1],
                    ix: 4,
                  },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [-60.336, -3.512], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Rectangle 1',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 0,
          op: 47,
          st: 15,
          bm: 0,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: '01',
      refId: 'comp_0',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [8.188, 8.062, 0], ix: 2 },
        a: { a: 0, k: [200, 200, 0], ix: 1 },
        s: { a: 0, k: [9.7, 9.7, 100], ix: 6 },
      },
      ao: 0,
      w: 400,
      h: 400,
      ip: 0,
      op: 32,
      st: 0,
      bm: 0,
    },
  ],
  markers: [
    { tm: 0, cm: 'wave_anim_stopped', dr: 8 },
    { tm: 8, cm: 'wave_anim_start', dr: 0 },
    { tm: 32, cm: 'wave_anim_end', dr: 0 },
  ],
};
